import { defineNuxtRouteMiddleware } from '#imports'
import { asRouteMiddleware, logOut } from '@router/route-guards'

export default defineNuxtRouteMiddleware(asRouteMiddleware(logOut))
